import { render } from "./fab-emoji-picker.vue?vue&type=template&id=b60ec270"
import script from "./fab-emoji-picker.vue?vue&type=script&lang=js"
export * from "./fab-emoji-picker.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/miqrositio/miqrositio_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__